import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import OptionedProductSectionForm from 'ui-shared/Forms/OptionedProductSectionForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const FoodSectionEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.virtualexperiencessections.editSection'}>
      <Edit>
        <OptionedProductSectionForm
          entity="virtuals"
          toolbar={<WithDeleteModalToolbar />}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default FoodSectionEdit
